import type { ReactElement } from 'react';
import {
  People24Regular,
  Key24Regular,
  ChartMultiple24Regular,
  DataLine24Regular,
  Emoji24Regular,
  ShieldTask24Regular,
  Navigation24Regular,
  Handshake24Regular,
  PuzzlePiece24Regular,
  Stethoscope24Regular,
  Flowchart24Regular,
} from '@fluentui/react-icons';
import type { MenuItem } from '../api/menuClient';

// Maps the DB's stored icon token (Font Awesome-style class from identity.Menu.Icon) OR a menu
// title to a Fluent icon. Keeps the icon choice data-driven while rendering with the Fluent library.
const ICONS: Record<string, ReactElement> = {
  'fas fa-user-shield': <ShieldTask24Regular />,
  'fas fa-users': <People24Regular />,
  'fas fa-key': <Key24Regular />,
  'fas fa-chart-bar': <ChartMultiple24Regular />,
  'fas fa-chart-line': <DataLine24Regular />,
  'fas fa-smile': <Emoji24Regular />,
  'fas fa-handshake': <Handshake24Regular />,
  'fas fa-puzzle-piece': <PuzzlePiece24Regular />,
  'fas fa-stethoscope': <Stethoscope24Regular />,
  'fas fa-project-diagram': <Flowchart24Regular />,
};

export function menuIcon(item: Pick<MenuItem, 'icon' | 'title'>): ReactElement {
  if (item.icon && ICONS[item.icon]) return ICONS[item.icon];
  // Title-based fallbacks so new nodes still get a sensible glyph without an exact icon match.
  const t = item.title.toLowerCase();
  if (t.includes('partner')) return <Handshake24Regular />;
  if (t.includes('widget')) return <PuzzlePiece24Regular />;
  if (t.includes('user')) return <People24Regular />;
  if (t.includes('permission')) return <Key24Regular />;
  if (t.includes('report')) return <ChartMultiple24Regular />;
  if (t.includes('diagnostic')) return <Stethoscope24Regular />;
  return <Navigation24Regular />;
}
